<template>
     <v-container fluid>
         <v-card>
            <v-toolbar>
                <v-icon>cloud_download</v-icon>
                <v-toolbar-title class="font-weight-light">&nbsp;Reporte de Consultas</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                    <v-icon v-if="action.esFrecuente">favorite</v-icon>
                    <v-icon v-else>favorite_border</v-icon>
                    </v-btn>
                </template>
                <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
                <span v-else>Agregar a Tareas Frecuentes</span>  
                </v-tooltip>
            </v-toolbar>
            <v-card-text>
                <span class="title" >Filtros</span>
                <v-divider></v-divider>
                <v-row dense>
                    <v-col cols="6" lg="3">
                        <v-autocomplete v-model="filtro.empresaId" :items="listEmpresas" autocomplete="disabled"
                            item-text="nombre" item-value="id" label="Créditos de la Empresa" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                    </v-col>
                    <v-col cols="6" lg="3">
                        <v-select
                            :items="listSucursalesEmpresa"
                            v-model="filtro.sucursales"
                            item-text="nombre"
                            item-value="id"
                            label="de las Sucursales"
                            multiple>
                            <!-- ABAJO esto es para agregar la opción de select all -->
                            <template v-slot:prepend-item>
                            <v-list-item
                                ripple
                                @click="toggleSucursales"
                            >
                                <v-list-item-action>
                                <v-icon :color="filtro.sucursales.length > 0 ? 'indigo darken-4' : ''">{{ iconSucursales }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                <v-list-item-title>Marcar todas</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                            </template>
                            <!-- ARRIBA esto es para agregar la opción de select all -->
                            <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                                <span>{{ item.nombre }}</span>
                            </v-chip>
                            <span
                                v-if="index === 1"
                                class="grey--text caption"
                            >(+{{ filtro.sucursales.length - 1 }} más)</span>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="6" lg="3">
                       <v-text-field v-model="filtro.fechaDesde" label="Ingresadas Desde" type="date" prepend-icon="event"></v-text-field>
                    </v-col>
                    <v-col cols="6" lg="3">
                       <v-text-field v-model="filtro.fechaHasta" label="Ingresadas Hasta" type="date" prepend-icon="event"></v-text-field>
                    </v-col>
                </v-row>

                <span class="title" >Opciones</span>
                <v-divider></v-divider>
                <v-row dense>
                    <v-col cols="6" lg="3">
                        <v-switch v-model="filtro.modoSimple" label="Formato Simple (sin encabezados)"></v-switch>
                    </v-col>                    
                </v-row>

            </v-card-text>
            <v-card-actions>
                <!-- <v-btn dark  color="green" @click="procesarBase">
                    Descargar Archivo&nbsp;
                    <v-icon >cloud_download</v-icon>                  
                </v-btn> -->
                <v-spacer></v-spacer>
                <v-btn dark  color="green" @click="procesarReporte">
                    Generar Reporte&nbsp;
                </v-btn>
            </v-card-actions>

         </v-card>

        <app-loading :loading="loading"></app-loading>

     </v-container>
</template>
<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data() {
        return {
            loading: false,
            filtro: {
                    empresaId: 1, 
                    sucursales: [],
                    fechaDesde: null, 
                    fechaHasta: null,
                    modoSimple: false,
            },
            listEmpresas: [],
            listSucursales: [],
            listSucursalesEmpresa: []
        }
    },
    async created() {
      await this.loadEmpresas();
      this.loadSucursales();

      this.filtro.fechaDesde = this.$moment().startOf('month').format('YYYY-MM-DD');
      this.filtro.fechaHasta = this.$moment(new Date()).format('YYYY-MM-DD');      
    }, 
    computed: {
        ...mapGetters(['activeTask','getActionFromLink','user','closeRelatedTasks']),
        action: function(){
            return this.getActionFromLink(this.$route.path) 
        },
        todasLasSucursalesMarcadas () {
            return this.filtro.sucursales.length === this.listSucursalesEmpresa.length;
        },
        algunasSucursalesMarcadas () {
            return this.filtro.sucursales.length > 0 && !this.todasLasSucursalesMarcadas
        },
        iconSucursales () {
            if (this.todasLasSucursalesMarcadas) return 'mdi-close-box'
            if (this.algunasSucursalesMarcadas) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        }
    },
    watch: {
        'filtro.empresaId': function(){
            if(!this.listSucursales) 
                this.listSucursalesEmpresa = [];
            else{
                this.listSucursalesEmpresa = this.listSucursales.filter(s => s.empresaId == this.filtro.empresaId);
                this.toggleSucursales();
            }
        }
    },
  methods: {
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError","setReporteActivo"]),
    ...mapActions(['setStatusTareaFrecuente']),    
    async loadEmpresas(){
        this.loading = true;
        try{
            var result = await http.get('empresas/list/porusuario?usuarioId='+this.user.id);

            this.listEmpresas = result.list;
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadSucursales(){
      this.loading = true;
      try{
        var result = await http.get('sucursales/list/porusuario?usuarioId='+this.user.id);

        this.listSucursales = result.list;
        this.listSucursalesEmpresa = this.listSucursales.filter(s => s.empresaId == this.filtro.empresaId);

        this.toggleSucursales();
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    toggleSucursales(){
        this.$nextTick(() => {
          if (this.todasLasSucursalesMarcadas) {
            this.filtro.sucursales = []
          } else {
            this.filtro.sucursales = this.listSucursalesEmpresa.map(function(p) {return p.id;});
          }
        })
    },
    validar(){
        if(this.filtro.empresaId === 0) 
        {
            this.alertWarning('Debe seleccionar una Empresa.');
            return false;
        }

        if(this.filtro.sucursales.length === 0)
        {
            this.alertWarning('Debe seleccionar al menos una Sucursal.');
            return false;
        }

        return true;
    },
    async procesarReporte(){

        // validaciones
        if(!this.validar()) 
        {
            return;
        }

        var self = this;

        try {
            self.loading = true;
            
            let params = [];
            params.push({
                "Version": this.$store.state.version,
                "EmpresaId": this.filtro.empresaId,
                "Sucursales": this.filtro.sucursales.join(','),
                "Empresa": this.listEmpresas.find(i=> i.id == this.filtro.empresaId).nombre,
                "Sucursal": this.listSucursalesEmpresa.filter(i=> this.filtro.sucursales.includes(i.id)).map(s => s.nombre).join(', '),
                "FechaDesde": this.filtro.fechaDesde,
                "FechaHasta": this.filtro.fechaHasta,
                "ModoSimple": this.filtro.modoSimple
            } );

            this.setReporteActivo({reporte: 'Consultas Detallado.trdp', params: params})
            window.open('/report-viewer');            
            
        } catch (error) {
            // Error
            self.alertError(error)
        }
        self.loading = false
    },
},
  
}
</script>